// extracted by mini-css-extract-plugin
module.exports = {"pageContent":"QrCode_pageContent__OvjFp","pageContentBody":"QrCode_pageContentBody__3cYbl"};